
import { ComponentCategory, ComponentOption } from "@/types/types";

// Helper function to get the scale based on the fan size
const getFanScale = (size: '120mm' | '140mm'): [number, number, number] => {
  const thickness = 0.025; // 25mm
  switch (size) {
    case '120mm':
      return [0.12, thickness, 0.12];
    case '140mm':
      return [0.14, thickness, 0.14];
    default:
      return [0.12, thickness, 0.12]; // Default to 120mm
  }
};

const baseFans: Omit<ComponentOption, 'socketType' | 'modelPath' | 'scale'>[] = [
    {
      id: "fan-1",
      name: "COSMIQ - Black",
      brand: "AsiaHorse",
      price: 20,
      amazonLink: "https://amzn.to/4elUSRL",
      specs: {
        type: "Case Fan",
        size: "120mm",
        airflow: "52 CFM",
        rgb: "Yes",
        noise: "26 dBA",
      },
      imageUrl: "https://xyhebqsgccwvmigqkwam.supabase.co/storage/v1/object/public/product-images//71sgNBTR-pL._SL1500_-removebg-preview.avif"
    },
    {
      id: "fan-2",
      name: "COSMIQ - White",
      brand: "AsiaHorse",
      price: 20,
      amazonLink: "https://amzn.to/4elUSRL",
      specs: {
        type: "Case Fan",
        size: "120mm",
        airflow: "52 CFM",
        rgb: "Yes",
        noise: "26 dBA",
      },
      imageUrl: "https://xyhebqsgccwvmigqkwam.supabase.co/storage/v1/object/public/product-images//714bD0Qu0-L._SL1500_.avif"
    },
    {
      id: "fan-3",
      name: "UNI Fan SL - LCD Wireless White",
      brand: "Lian Li",
      price: 50,
      amazonLink: "https://amzn.to/4emRO7V",
      specs: {
        type: "Case Fan",
        size: "120mm",
        airflow: "52 CFM",
        rgb: "Yes",
        noise: "26 dBA",
      },
      imageUrl: "https://xyhebqsgccwvmigqkwam.supabase.co/storage/v1/object/public/product-images//714bD0Qu0-L._SL1500_.avif"
    },
    {
      id: "fan-4",
      name: "UNI Fan SL - LCD Wireless Black",
      brand: "Lian Li",
      price: 50,
      amazonLink: "https://amzn.to/4emRO7V",
      specs: {
        type: "Case Fan",
        size: "120mm",
        airflow: "52 CFM",
        rgb: "Yes",
        noise: "26 dBA",
      },
      imageUrl: "https://xyhebqsgccwvmigqkwam.supabase.co/storage/v1/object/public/product-images//714bD0Qu0-L._SL1500_.avif"
    },
    {
      id: "fan-5",
      name: "NF-P12 - NO RGB",
      brand: "Noctua",
      price: 19,
      amazonLink: "#",
      specs: {
        type: "Case Fan",
        size: "140mm",
        airflow: "68 CFM",
        rgb: "No",
        noise: "19 dBA",
      },
      imageUrl: "https://images.unsplash.com/photo-1624914023435-4cf3cb4e6e25?q=80&w=2574&auto=format"
    },
    {
      id: "fan-6",
      name: "Pure Wings 3",
      brand: "Be quiet!",
      price: 14,
      amazonLink: "#",
      specs: {
        type: "Case Fan",
        size: "140mm",
        airflow: "68 CFM",
        rgb: "Yes",
        noise: "19 dBA",
      },
      imageUrl: "https://images.unsplash.com/photo-1624914023435-4cf3cb4e6e25?q=80&w=2574&auto=format"
    },
    {
      id: "fan-7",
      name: "Pure Wings 3",
      brand: "Be quiet!",
      price: 14,
      amazonLink: "#",
      specs: {
        type: "Case Fan",
        size: "140mm",
        airflow: "68 CFM",
        rgb: "Yes",
        noise: "19 dBA",
      },
      imageUrl: "https://images.unsplash.com/photo-1624914023435-4cf3cb4e6e25?q=80&w=2574&auto=format"
    }
];

export const fanComponents: ComponentCategory = {
  id: "fans",
  name: "Additional Fans",
  description: "Add more cooling capacity to your system.",
  required: false,
  options: baseFans.map(fan => ({
    ...fan,
    socketType: 'FAN_MOUNT',
    modelPath: '/models/fan.glb', // Using a generic fan model for now
    scale: getFanScale(fan.specs.size as '120mm' | '140mm'),
  })),
};
